var render, staticRenderFns
import script from "./MarzipanoScene.vue?vue&type=script&lang=js&"
export * from "./MarzipanoScene.vue?vue&type=script&lang=js&"
import style0 from "./MarzipanoScene.vue?vue&type=style&index=0&id=4e605f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e605f6e",
  null
  
)

export default component.exports